import { useState, useEffect } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import Button from "../../../../Custom/Button/Button";
import CustomSelect from "../CustomSelect";
import CustomSelectSimple from "../CustomSelectSimple";
import axios from "axios";

const sredstvoMock = {
  naziv: "",
  tip: "",
  model: "",
  godinaProizvodnje: "",
  idBroj: "",
  registracija: "",
  poslovnaJedinica: { id: -1, name: "" },
  prikljucniUredjaji: { id: -1, name: "" },
};

const styles = {
  input: {
    width: "100%",
    fontSize: "16px",
    height: "40px",
    padding: "10px",
  },
};

function DodavanjeSredstva({ setCurrentState }) {
  const [sredstvo, setSredstvo] = useState(sredstvoMock);
  const [poslovneJediniceAll, setPoslovneJediniceAll] = useState([]);
  const [prikljucniUredjajiAll, setPrikljucniUredjajiAll] = useState([]);
  const [godine, setGodine] = useState([]);

  const { dictionary, baseUrl, apiKey, loggedUser } = useGlobalContext();

  // Učitavanje šifarnika - identično kao u Folder.js
  useEffect(() => {
    if (!loggedUser || !apiKey) return;

    const authPayload = {
      user_id: loggedUser.id,
      api_key: apiKey,
      company_id: 1,
    };

    const fetchData = async () => {
      try {
        const resUnits = await axios.post(
          `${baseUrl}/unit/read.php`,
          authPayload,
        );
        if (resUnits.data.status === 200)
          setPoslovneJediniceAll(resUnits.data.data);

        const resAttachments = await axios.post(
          `${baseUrl}/attachments/read.php`,
          authPayload,
        );
        if (resAttachments.data.status === 200) {
          // Mapiramo podatke tako da naziv postane name
          const formattedAttachments = resAttachments.data.data.map((item) => ({
            id: item.id,
            name: item.naziv, // Ovde pravimo name od naziva
          }));
          setPrikljucniUredjajiAll(formattedAttachments);
        }

        const resYears = await axios.post(
          `${baseUrl}/years/read.php`,
          authPayload,
        );
        if (resYears.data.status === 200) {
          const yearsArray = resYears.data.data.map((y) => y.godina);
          setGodine(yearsArray);
        }
      } catch (error) {
        console.error("Greška pri učitavanju šifarnika", error);
      }
    };

    fetchData();
  }, [loggedUser, apiKey, baseUrl]);

  const handleChange = (field, value) => {
    setSredstvo((prev) => ({ ...prev, [field]: value }));
  };

  const handleNazad = () => {
    setCurrentState("");
  };

  const handleDodaj = async () => {
    // 1. Osnovna provera podataka
    if (!loggedUser || !apiKey) {
      alert("Greška: Niste ulogovani.");
      return;
    }

    if (!sredstvo.naziv || !sredstvo.idBroj) {
      alert("Molimo popunite naziv i ID broj mašine.");
      return;
    }

    // 2. Mapiranje podataka za backend
    // Obrati pažnju: godina_id dobijamo traženjem indeksa u nizu godina
    const payload = {
      user_id: loggedUser.id,
      api_key: apiKey,
      company_id: 1,
      naziv: sredstvo.naziv,
      tip: sredstvo.tip,
      model: sredstvo.model,
      // Ako su godine u bazi ID-evima 1, 2, 3... a niz kreće od 0
      godina_id: godine.indexOf(sredstvo.godinaProizvodnje) + 1,
      identifikacioni_broj: sredstvo.idBroj,
      registracija: sredstvo.registracija,
      poslovna_jedinica_id: sredstvo.poslovnaJedinica.id,
      // Backend očekuje niz ID-jeva za priključne uređaje
      prikljucni_uredjaji:
        sredstvo.prikljucniUredjaji.id !== -1
          ? [sredstvo.prikljucniUredjaji.id]
          : [],
    };

    console.log("Šaljem podatke za kreiranje mašine:", payload);

    try {
      // 3. Poziv endpointa
      const { data } = await axios.post(
        `${baseUrl}/machines/upsert_machine.php`,
        payload,
      );

      if (data.status === 201 || data.operation === "created") {
        alert("Mašina je uspešno sačuvana!");
        setCurrentState(""); // Zatvara formu/vraća na listu
        window.dispatchEvent(new Event("machineAdded"));
      } else {
        alert(data.message || "Greška pri snimanju mašine.");
      }
    } catch (error) {
      console.error("Greška pri slanju mašine", error);
      alert("Došlo je do greške na serveru.");
    }
  };

  return (
    <div
      style={{
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <input
        value={sredstvo.naziv}
        onChange={(e) => handleChange("naziv", e.target.value)}
        placeholder={dictionary["naziv"]}
        style={styles.input}
      />
      <input
        value={sredstvo.tip}
        onChange={(e) => handleChange("tip", e.target.value)}
        placeholder={dictionary["tip"]}
        style={styles.input}
      />
      <input
        value={sredstvo.model}
        onChange={(e) => handleChange("model", e.target.value)}
        placeholder={dictionary["model"]}
        style={styles.input}
      />
      <CustomSelectSimple
        label={dictionary["godinaProizvodnje"]}
        allValues={godine}
        selectedValue={sredstvo.godinaProizvodnje}
        onSelectChange={(newValue) =>
          handleChange("godinaProizvodnje", newValue)
        }
      />
      <input
        value={sredstvo.idBroj}
        onChange={(e) => handleChange("idBroj", e.target.value)}
        placeholder={dictionary["idBroj"]}
        style={styles.input}
      />
      <input
        value={sredstvo.registracija}
        onChange={(e) => handleChange("registracija", e.target.value)}
        placeholder={dictionary["registracija"]}
        style={styles.input}
      />
      <CustomSelect
        label={dictionary["poslovnaJedinica"]}
        allValues={poslovneJediniceAll}
        selectedValue={sredstvo.poslovnaJedinica}
        onSelectChange={(newValue) =>
          handleChange("poslovnaJedinica", newValue)
        }
      />
      <CustomSelect
        label={dictionary["prikljucniUredjaji"]}
        allValues={prikljucniUredjajiAll}
        selectedValue={sredstvo.prikljucniUredjaji}
        onSelectChange={(newValue) =>
          handleChange("prikljucniUredjaji", newValue)
        }
      />

      <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
        <div onClick={handleDodaj} style={{ flex: 1 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            {dictionary["dodaj"]}
          </Button>
        </div>

        <div onClick={handleNazad} style={{ flex: 1 }}>
          <Button activation={true} style={{ padding: "10px", width: "100%" }}>
            НАЗАД
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DodavanjeSredstva;
